import React from 'react'
import img1 from './S/Slide_1.png';
import img2 from './S/Slide_2.png';
import img3 from './S/Slide_3.png';
import img4 from './S/Slide_4.png';
import img5 from './S/Slide_5.png';
import img6 from './S/Slide_6.png';
import img7 from './S/Slide_7.png';
import img8 from './S/Slide_8.png';
import img9 from './S/Slide_9.png';
import img10 from './S/Slide_10.png';
import img11 from './S/Slide_11.png';
import img12 from './S/Slide_12.png';
import img13 from './S/Slide_13.png';
import img14 from './S/Slide_14.png';
import img15 from './S/Slide_15.png';
import img16 from './S/Slide_16.png';
import img17 from './S/Slide_17.png';
import img18 from './S/Slide_18.png';
import img20 from './S/Slide_19.png';
import img21 from './S/Slide_20.png';
import img22 from './S/Slide_21.png';
import img23 from './S/Slide_22.png';
import img24 from './S/Slide_23.png';
import img25 from './S/Slide_24.png';
import img26 from './S/Slide_25.png';
import img27 from './S/Slide_26.png';
import img28 from './S/Slide_27.png';
import img29 from './S/Slide_28.png';
import img30 from './S/Slide_29.png';
import img31 from './S/Slide_30.png';
import img32 from './S/Slide_31.png';
import img33 from './S/Slide_32.png';
import img34 from './S/Slide_33.png';
import img35 from './S/Slide_34.png';
import img36 from './S/Slide_35.png';
import img37 from './S/Slide_36.png';
import img38 from './S/Slide_37.png';
import img39 from './S/Slide_38.png';
import img40 from './S/Slide_39.png';


// exam

import img1e from './exam/Slide_1.png';
import img2e from './exam/Slide_2.png';
import img3e from './exam/Slide_3.png';
import img4e from './exam/Slide_4.png';
import img5e from './exam/Slide_5.png';
import img6e from './exam/Slide_6.png';
import img7e from './exam/Slide_7.png';
import img8e from './exam/Slide_8.png';
import img9e from './exam/Slide_9.png';
import img10e from './exam/Slide_10.png';
import img11e from './exam/Slide_11.png';
import img12e from './exam/Slide_12.png';
import img13e from './exam/Slide_13.png';
import img14e from './exam/Slide_14.png';
import img15e from './exam/Slide_15.png';
import img16e from './exam/Slide_16.png';
import img17e from './exam/Slide_17.png';
import img18e from './exam/Slide_18.png';
import img20e from './exam/Slide_19.png';
import img21e from './exam/Slide_20.png';
import img22e from './exam/Slide_21.png';
import img23e from './exam/Slide_22.png';
import img24e from './exam/Slide_23.png';
import img25e from './exam/Slide_24.png';
import img26e from './exam/Slide_25.png';
import img27e from './exam/Slide_26.png';
import img28e from './exam/Slide_27.png';
import img29e from './exam/Slide_28.png';
import img30e from './exam/Slide_29.png';
import img31e from './exam/Slide_30.png';
import img32e from './exam/Slide_31.png';
import img33e from './exam/Slide_32.png';
import img34e from './exam/Slide_33.png';
import img35e from './exam/Slide_34.png';
import img36e from './exam/Slide_35.png';
import img37e from './exam/Slide_36.png';
import img38e from './exam/Slide_37.png';
import img39e from './exam/Slide_38.png';
import img41e from './exam/Slide_41.png';
import img42e from './exam/Slide_42.png';
import img43e from './exam/Slide_43.png';

// tender

import imgt1 from './T/Slide_1.png';
import imgt2 from './T/Slide_2.png';

//  survey images 

export const Survey =[
    img1 ,
    img2 ,
    img3 ,
    img4 ,
    img5 ,
    img6 ,
    img7 ,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img20,
    img21,
    img22,
    img23,
    img24,
    img25,
    img26,
    img27,
    img28,
    img29,
    img30,
    img31,
    img32,
    img33,
    img34,
    img35,
    img36,
    img37,
    img38,
    img39,
    img40,
]

//tender

export const Tender=[

imgt1,
imgt2
]

//  examination

export const Exam = [

    img1e,
    img2e,
    img3e,
    img4e,
    img5e,
    img6e,
    img7e,
    img8e,
    img9e,
    img10e,
    img11e,
    img12e,
    img13e,
    img14e,
    img15e,
    img16e,
    img17e,
    img18e,
    img20e,
    img21e,
    img22e,
    img23e,
    img24e,
    img25e,
    img26e,
    img27e,
    img28e,
    img29e,
    img30e,
    img31e,
    img32e,
    img33e,
    img34e,
    img35e,
    img36e,
    img37e,
    img38e,
    img39e,
    img41e,
    img42e,
    img43e,
]

export const VimeoPlayer_survey = () => {
    return (
      <div style={{padding: '75% 0 0 0', position: 'relative'}}>
        <iframe src="https://player.vimeo.com/video/826605657?h=9e2cc3abbe&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}} title="utopiaIntro"></iframe>
      </div>
    );
  };
  
 

  export const VimeoPlayer_exam =  () => {
    return (
      <div style={{padding: '75% 0 0 0', position: 'relative'}}>
        <iframe src="https://player.vimeo.com/video/826647273?h=9e2cc3abbe&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}} title="utopiaIntro"></iframe>
      </div>
    );
  };
  
  
  // () => {
  //   return (
  //   <div style={{padding: '56.22% 0 0 0',position:'relative'}}>
  //       <iframe src="https://player.vimeo.com/video/826647273?h=7517abd821&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="examination app using (PHP,ajax,Jquery,bootsratp,CSS,HTML"></iframe>
  //   </div>
  //   );
  // };


  